import { EMAIL_VERIFICAION_AUTH_TYPE_CD } from "models/email-verification";

export default {
  namespaced: true,

  state: {
    signUp: null,
    resetPassword: null,
  },

  mutations: {
    RESET_STATE(state) {
      // state = detDefaultState()だと"Assignment to function parameter 'state'が発生する"
      state.signUp = null;
      state.resetPassword = null;
      // 以下の記述では、stateの更新がおこなわれていない
      // 変数stateに新しいオブジェクトのアドレスをセットしている。
      // 一方で、vuexで管理しているstoreは、別に管理のようで、古いアドレスのままのようである。
      // Object.assign(state, getDefaultState());
    },
    SIGN_UP_VERIFICATION(state, emailVerification) {
      state.signUp = emailVerification;
    },
    RESET_PASSWORD_VERIFICATION(state, emailVerification) {
      state.resetPassword = emailVerification;
    },
  },

  getters: {
    signUpEmailVarification(state) {
      let emailVerification = null;
      if (state.signUp) {
        emailVerification = state.signUp.copy();
      }
      return emailVerification;
    },
    resetPasswordEmailVarification(state) {
      let emailVerification = null;
      if (state.resetPassword) {
        emailVerification = state.resetPassword.copy();
      }
      return emailVerification;
    },
  },

  actions: {
    resetState({ commit }) {
      commit("RESET_STATE");
    },
    async updateSignUpEmailVerification({ commit }, emailVerification) {
      try {
        if (emailVerification.authTypeCd === EMAIL_VERIFICAION_AUTH_TYPE_CD.SIGN_UP) {
          commit("SIGN_UP_VERIFICATION", emailVerification);
        } else {
          // TODO:　異なる認証タイプのメール検証が登録された場合はエラーを返す
        }
      } catch (err) {
        // TODO: 発生したエラーを画面に反映
      }
    },
    async updateResetPasswordEmailVerification({ commit }, emailVerification) {
      try {
        if (emailVerification.authTypeCd === EMAIL_VERIFICAION_AUTH_TYPE_CD.RESET_PASSWORD) {
          commit("RESET_PASSWORD_VERIFICATION", emailVerification);
        } else {
          // TODO:　異なる認証タイプのメール検証が登録された場合はエラーを返す
        }
      } catch (err) {
        // TODO: 発生したエラーを画面に反映
      }
    },
  },
};
